exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".button-container-container-3N5Snhe6mwr{display:flex;align-items:center}.button-container-container-3N5Snhe6mwr.button-container-right-7FsFQqWSmwr{justify-content:flex-end}.button-container-container-3N5Snhe6mwr>*{flex:0 0 auto;margin-right:8px}.button-container-container-3N5Snhe6mwr>*:last-child{margin-right:0}.button-container-equal-width-2RnQaH3Lmwr{display:table;border-collapse:separate;border-spacing:8px 0;margin-left:-8px;margin-right:-8px}.button-container-equal-width-2RnQaH3Lmwr>*{display:table-cell;vertical-align:middle}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(1),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(1) ~ *{width:100%}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(2),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(2) ~ *{width:50%}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(3),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(3) ~ *{width:33.33333%}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(4),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(4) ~ *{width:25%}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(5),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(5) ~ *{width:20%}.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(6),.button-container-equal-width-2RnQaH3Lmwr>*:first-child:nth-last-child(6) ~ *{width:16.66667%}.button-container-equal-width-2RnQaH3Lmwr>*>*{width:100%}.button-container-full-width-1YrpNpL3mwr{width:100%;margin-left:0}.button-container-between-6wGdkgBSmwr{width:100%;justify-content:space-between}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "button-container-container-3N5Snhe6mwr",
	"right": "button-container-right-7FsFQqWSmwr",
	"equal-width": "button-container-equal-width-2RnQaH3Lmwr",
	"equalWidth": "button-container-equal-width-2RnQaH3Lmwr",
	"full-width": "button-container-full-width-1YrpNpL3mwr",
	"fullWidth": "button-container-full-width-1YrpNpL3mwr",
	"between": "button-container-between-6wGdkgBSmwr"
};